/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiBaseService } from '../api-base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ChangePasswordResult } from '../models/change-password-result';
import { CheckEmailForAuthenticationResult } from '../models/check-email-for-authentication-result';
import { getUserInfo } from '../fn/authentication/get-user-info';
import { GetUserInfo$Params } from '../fn/authentication/get-user-info';
import { GetUserInfoResult } from '../models/get-user-info-result';
import { getUserLikes } from '../fn/authentication/get-user-likes';
import { GetUserLikes$Params } from '../fn/authentication/get-user-likes';
import { GetUserLikesResult } from '../models/get-user-likes-result';
import { LoginWithJsonWebTokenResult } from '../models/login-with-json-web-token-result';
import { LoginWithPasswordResult } from '../models/login-with-password-result';
import { LoginWithSamlResult } from '../models/login-with-saml-result';
import { LoginWithSsoResult } from '../models/login-with-sso-result';
import { patchAccountEmail } from '../fn/authentication/patch-account-email';
import { PatchAccountEmail$Params } from '../fn/authentication/patch-account-email';
import { patchAccountInfos } from '../fn/authentication/patch-account-infos';
import { PatchAccountInfos$Params } from '../fn/authentication/patch-account-infos';
import { patchLikesByDishidUpdateNotification } from '../fn/authentication/patch-likes-by-dishid-update-notification';
import { PatchLikesByDishidUpdateNotification$Params } from '../fn/authentication/patch-likes-by-dishid-update-notification';
import { postBalanceAlert } from '../fn/authentication/post-balance-alert';
import { PostBalanceAlert$Params } from '../fn/authentication/post-balance-alert';
import { postChangePassword } from '../fn/authentication/post-change-password';
import { PostChangePassword$Params } from '../fn/authentication/post-change-password';
import { postCheckEmail } from '../fn/authentication/post-check-email';
import { PostCheckEmail$Params } from '../fn/authentication/post-check-email';
import { postForgotPassword } from '../fn/authentication/post-forgot-password';
import { PostForgotPassword$Params } from '../fn/authentication/post-forgot-password';
import { postLogin } from '../fn/authentication/post-login';
import { PostLogin$Params } from '../fn/authentication/post-login';
import { postLoginJwt } from '../fn/authentication/post-login-jwt';
import { PostLoginJwt$Params } from '../fn/authentication/post-login-jwt';
import { postLoginSaml } from '../fn/authentication/post-login-saml';
import { PostLoginSaml$Params } from '../fn/authentication/post-login-saml';
import { postLoginSso } from '../fn/authentication/post-login-sso';
import { PostLoginSso$Params } from '../fn/authentication/post-login-sso';
import { postRefresh } from '../fn/authentication/post-refresh';
import { PostRefresh$Params } from '../fn/authentication/post-refresh';
import { postResetPassword } from '../fn/authentication/post-reset-password';
import { PostResetPassword$Params } from '../fn/authentication/post-reset-password';
import { postSsoSamlAcsBySitename } from '../fn/authentication/post-sso-saml-acs-by-sitename';
import { PostSsoSamlAcsBySitename$Params } from '../fn/authentication/post-sso-saml-acs-by-sitename';
import { putLanguage } from '../fn/authentication/put-language';
import { PutLanguage$Params } from '../fn/authentication/put-language';
import { RefreshTokenResult } from '../models/refresh-token-result';
import { UpdateAccountInfosResult } from '../models/update-account-infos-result';
import { UpdateEmailResult } from '../models/update-email-result';

@Injectable({ providedIn: 'root' })
export class ApiAuthenticationService extends ApiBaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postAuthenticationChangePassword()` */
  static readonly PostAuthenticationChangePasswordPath = '/Authentication/change-password';

  /**
   * post-authentication-change-password.
   *
   * Change Password<br>Change password with new value
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postChangePassword()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postChangePassword$Response(params?: PostChangePassword$Params, context?: HttpContext): Observable<StrictHttpResponse<ChangePasswordResult>> {
    return postChangePassword(this.http, this.rootUrl, params, context);
  }

  /**
   * post-authentication-change-password.
   *
   * Change Password<br>Change password with new value
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postChangePassword$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postChangePassword(params?: PostChangePassword$Params, context?: HttpContext): Observable<ChangePasswordResult> {
    return this.postChangePassword$Response(params, context).pipe(map((r: StrictHttpResponse<ChangePasswordResult>): ChangePasswordResult => r.body));
  }

  /** Path part for operation `postAuthenticationCheckEmail()` */
  static readonly PostAuthenticationCheckEmailPath = '/Authentication/check-email';

  /**
   * post-authentication-check-email.
   *
   * Check Email for Authentication<br>Forces SAML SSO when required, without revealing if the email exists.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postCheckEmail()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postCheckEmail$Response(params?: PostCheckEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<CheckEmailForAuthenticationResult>> {
    return postCheckEmail(this.http, this.rootUrl, params, context);
  }

  /**
   * post-authentication-check-email.
   *
   * Check Email for Authentication<br>Forces SAML SSO when required, without revealing if the email exists.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postCheckEmail$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postCheckEmail(params?: PostCheckEmail$Params, context?: HttpContext): Observable<CheckEmailForAuthenticationResult> {
    return this.postCheckEmail$Response(params, context).pipe(
      map((r: StrictHttpResponse<CheckEmailForAuthenticationResult>): CheckEmailForAuthenticationResult => r.body),
    );
  }

  /** Path part for operation `postAuthenticationForgotPassword()` */
  static readonly PostAuthenticationForgotPasswordPath = '/Authentication/forgot-password';

  /**
   * post-authentication-forgot-password.
   *
   * Forgot password<br>Send email to reset password
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postForgotPassword()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postForgotPassword$Response(params?: PostForgotPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postForgotPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * post-authentication-forgot-password.
   *
   * Forgot password<br>Send email to reset password
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postForgotPassword$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postForgotPassword(params?: PostForgotPassword$Params, context?: HttpContext): Observable<void> {
    return this.postForgotPassword$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `getAuthenticationUserInfo()` */
  static readonly GetAuthenticationUserInfoPath = '/Authentication/user-info';

  /**
   * get-authentication-user-info.
   *
   * Get User Informations<br>Get User Informations (usual /me)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserInfo$Response(params?: GetUserInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserInfoResult>> {
    return getUserInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * get-authentication-user-info.
   *
   * Get User Informations<br>Get User Informations (usual /me)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserInfo(params?: GetUserInfo$Params, context?: HttpContext): Observable<GetUserInfoResult> {
    return this.getUserInfo$Response(params, context).pipe(map((r: StrictHttpResponse<GetUserInfoResult>): GetUserInfoResult => r.body));
  }

  /** Path part for operation `getAuthenticationUserLikes()` */
  static readonly GetAuthenticationUserLikesPath = '/Authentication/user-likes';

  /**
   * get-authentication-user-likes.
   *
   * Get User Likes
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserLikes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserLikes$Response(params?: GetUserLikes$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserLikesResult>> {
    return getUserLikes(this.http, this.rootUrl, params, context);
  }

  /**
   * get-authentication-user-likes.
   *
   * Get User Likes
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserLikes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserLikes(params?: GetUserLikes$Params, context?: HttpContext): Observable<GetUserLikesResult> {
    return this.getUserLikes$Response(params, context).pipe(map((r: StrictHttpResponse<GetUserLikesResult>): GetUserLikesResult => r.body));
  }

  /** Path part for operation `postAuthenticationLoginJwt()` */
  static readonly PostAuthenticationLoginJwtPath = '/Authentication/login/jwt';

  /**
   * post-authentication-login-jwt.
   *
   * Login with Json Web Token<br>Login method with Json Web Token
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postLoginJwt()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postLoginJwt$Response(params?: PostLoginJwt$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginWithJsonWebTokenResult>> {
    return postLoginJwt(this.http, this.rootUrl, params, context);
  }

  /**
   * post-authentication-login-jwt.
   *
   * Login with Json Web Token<br>Login method with Json Web Token
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postLoginJwt$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postLoginJwt(params?: PostLoginJwt$Params, context?: HttpContext): Observable<LoginWithJsonWebTokenResult> {
    return this.postLoginJwt$Response(params, context).pipe(map((r: StrictHttpResponse<LoginWithJsonWebTokenResult>): LoginWithJsonWebTokenResult => r.body));
  }

  /** Path part for operation `postAuthenticationLogin()` */
  static readonly PostAuthenticationLoginPath = '/Authentication/login';

  /**
   * post-authentication-login.
   *
   * Login with Password<br>Login method with user/password
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postLogin()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postLogin$Response(params?: PostLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginWithPasswordResult>> {
    return postLogin(this.http, this.rootUrl, params, context);
  }

  /**
   * post-authentication-login.
   *
   * Login with Password<br>Login method with user/password
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postLogin$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postLogin(params?: PostLogin$Params, context?: HttpContext): Observable<LoginWithPasswordResult> {
    return this.postLogin$Response(params, context).pipe(map((r: StrictHttpResponse<LoginWithPasswordResult>): LoginWithPasswordResult => r.body));
  }

  /** Path part for operation `postAuthenticationLoginSaml()` */
  static readonly PostAuthenticationLoginSamlPath = '/Authentication/login/saml';

  /**
   * post-authentication-login-saml.
   *
   * Login with SAML<br>Login method with SAML
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postLoginSaml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postLoginSaml$Response(params?: PostLoginSaml$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginWithSamlResult>> {
    return postLoginSaml(this.http, this.rootUrl, params, context);
  }

  /**
   * post-authentication-login-saml.
   *
   * Login with SAML<br>Login method with SAML
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postLoginSaml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postLoginSaml(params?: PostLoginSaml$Params, context?: HttpContext): Observable<LoginWithSamlResult> {
    return this.postLoginSaml$Response(params, context).pipe(map((r: StrictHttpResponse<LoginWithSamlResult>): LoginWithSamlResult => r.body));
  }

  /** Path part for operation `postSsoSamlAcsBySitename()` */
  static readonly PostSsoSamlAcsBySitenamePath = '/sso/saml/acs/{SiteName}';

  /**
   * post-sso-saml-acs-by-sitename.
   *
   * SAML Assertion Consumer Service (ACS)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postSsoSamlAcsBySitename()` instead.
   *
   * This method doesn't expect any request body.
   */
  postSsoSamlAcsBySitename$Response(params: PostSsoSamlAcsBySitename$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postSsoSamlAcsBySitename(this.http, this.rootUrl, params, context);
  }

  /**
   * post-sso-saml-acs-by-sitename.
   *
   * SAML Assertion Consumer Service (ACS)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postSsoSamlAcsBySitename$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postSsoSamlAcsBySitename(params: PostSsoSamlAcsBySitename$Params, context?: HttpContext): Observable<void> {
    return this.postSsoSamlAcsBySitename$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `postAuthenticationLoginSso()` */
  static readonly PostAuthenticationLoginSsoPath = '/Authentication/login/sso';

  /**
   * post-authentication-login-sso.
   *
   * Login with SSO<br>Login method with SSO (token)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postLoginSso()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postLoginSso$Response(params?: PostLoginSso$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginWithSsoResult>> {
    return postLoginSso(this.http, this.rootUrl, params, context);
  }

  /**
   * post-authentication-login-sso.
   *
   * Login with SSO<br>Login method with SSO (token)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postLoginSso$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postLoginSso(params?: PostLoginSso$Params, context?: HttpContext): Observable<LoginWithSsoResult> {
    return this.postLoginSso$Response(params, context).pipe(map((r: StrictHttpResponse<LoginWithSsoResult>): LoginWithSsoResult => r.body));
  }

  /** Path part for operation `postAuthenticationRefresh()` */
  static readonly PostAuthenticationRefreshPath = '/Authentication/refresh';

  /**
   * post-authentication-refresh.
   *
   * Refresh authorization token<br>Get a new authorization token
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postRefresh()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postRefresh$Response(params?: PostRefresh$Params, context?: HttpContext): Observable<StrictHttpResponse<RefreshTokenResult>> {
    return postRefresh(this.http, this.rootUrl, params, context);
  }

  /**
   * post-authentication-refresh.
   *
   * Refresh authorization token<br>Get a new authorization token
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postRefresh$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postRefresh(params?: PostRefresh$Params, context?: HttpContext): Observable<RefreshTokenResult> {
    return this.postRefresh$Response(params, context).pipe(map((r: StrictHttpResponse<RefreshTokenResult>): RefreshTokenResult => r.body));
  }

  /** Path part for operation `postAuthenticationResetPassword()` */
  static readonly PostAuthenticationResetPasswordPath = '/Authentication/reset-password';

  /**
   * post-authentication-reset-password.
   *
   * Reset password<br>Reset forgotten password
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postResetPassword()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postResetPassword$Response(params?: PostResetPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postResetPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * post-authentication-reset-password.
   *
   * Reset password<br>Reset forgotten password
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postResetPassword$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postResetPassword(params?: PostResetPassword$Params, context?: HttpContext): Observable<void> {
    return this.postResetPassword$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `patchAuthenticationAccountInfos()` */
  static readonly PatchAuthenticationAccountInfosPath = '/Authentication/account-infos';

  /**
   * patch-authentication-account-infos.
   *
   * Update Account Infos<br>
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchAccountInfos()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchAccountInfos$Response(params?: PatchAccountInfos$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateAccountInfosResult>> {
    return patchAccountInfos(this.http, this.rootUrl, params, context);
  }

  /**
   * patch-authentication-account-infos.
   *
   * Update Account Infos<br>
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchAccountInfos$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchAccountInfos(params?: PatchAccountInfos$Params, context?: HttpContext): Observable<UpdateAccountInfosResult> {
    return this.patchAccountInfos$Response(params, context).pipe(map((r: StrictHttpResponse<UpdateAccountInfosResult>): UpdateAccountInfosResult => r.body));
  }

  /** Path part for operation `postAuthenticationBalanceAlert()` */
  static readonly PostAuthenticationBalanceAlertPath = '/Authentication/balance-alert';

  /**
   * post-authentication-balance-alert.
   *
   * Update Balance alert<br>update balance alert for authenticated user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postBalanceAlert()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postBalanceAlert$Response(params?: PostBalanceAlert$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postBalanceAlert(this.http, this.rootUrl, params, context);
  }

  /**
   * post-authentication-balance-alert.
   *
   * Update Balance alert<br>update balance alert for authenticated user
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postBalanceAlert$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postBalanceAlert(params?: PostBalanceAlert$Params, context?: HttpContext): Observable<void> {
    return this.postBalanceAlert$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `patchAuthenticationLikesByDishidUpdateNotification()` */
  static readonly PatchAuthenticationLikesByDishidUpdateNotificationPath = '/Authentication/likes/{DishId}/update-notification';

  /**
   * patch-authentication-likes-by-dishid-update-notification.
   *
   * Update Dish like notification<br>
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchLikesByDishidUpdateNotification()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchLikesByDishidUpdateNotification$Response(
    params: PatchLikesByDishidUpdateNotification$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<void>> {
    return patchLikesByDishidUpdateNotification(this.http, this.rootUrl, params, context);
  }

  /**
   * patch-authentication-likes-by-dishid-update-notification.
   *
   * Update Dish like notification<br>
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchLikesByDishidUpdateNotification$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchLikesByDishidUpdateNotification(params: PatchLikesByDishidUpdateNotification$Params, context?: HttpContext): Observable<void> {
    return this.patchLikesByDishidUpdateNotification$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `patchAuthenticationAccountEmail()` */
  static readonly PatchAuthenticationAccountEmailPath = '/Authentication/account-email';

  /**
   * patch-authentication-account-email.
   *
   * Update Account email<br>
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchAccountEmail()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchAccountEmail$Response(params?: PatchAccountEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateEmailResult>> {
    return patchAccountEmail(this.http, this.rootUrl, params, context);
  }

  /**
   * patch-authentication-account-email.
   *
   * Update Account email<br>
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchAccountEmail$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchAccountEmail(params?: PatchAccountEmail$Params, context?: HttpContext): Observable<UpdateEmailResult> {
    return this.patchAccountEmail$Response(params, context).pipe(map((r: StrictHttpResponse<UpdateEmailResult>): UpdateEmailResult => r.body));
  }

  /** Path part for operation `putAuthenticationLanguage()` */
  static readonly PutAuthenticationLanguagePath = '/Authentication/language';

  /**
   * put-authentication-language.
   *
   * Update Preferred Language<br>
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putLanguage()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putLanguage$Response(params?: PutLanguage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return putLanguage(this.http, this.rootUrl, params, context);
  }

  /**
   * put-authentication-language.
   *
   * Update Preferred Language<br>
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putLanguage$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putLanguage(params?: PutLanguage$Params, context?: HttpContext): Observable<void> {
    return this.putLanguage$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }
}
